<div class="image"
     [style.background-image]="'url(' + (imageUrl ? imageUrl : ('/assets/images/products/' + projectPropertyName.toLowerCase() + 's/' + projectProperty.code + '.jpg')) + ')'">
  <div class="zoom-control-container" *ngIf="enlargedImageUrl">
    <button (click)="openZoomDialog()"
            mat-mini-fab color="tertiary">
      <mat-icon svgIcon="magnify-plus"></mat-icon>
    </button>
  </div>
  <span>
    {{ title ? title : '' }}
    <span *ngIf="projectPropertyName === 'bag'" class="sub-title">
      for artwork up to {{project.size }}
    </span>
  </span>
</div>
